var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"generic-toggle-button p-1 rounded-full outline-none",on:{"click":function($event){$event.preventDefault();return _vm.changeValue($event)}}},[_c('div',{staticClass:"generic-toggle-button__background transition-all",class:{
      'generic-toggle-button__background--active': _vm.value,
      'generic-toggle-button__background--inactive': !_vm.value,
    }},[_c('div',{staticClass:"generic-toggle-button__toggle",class:{
        'translate-x-8 border-aquamarine': _vm.value,
      }},[_c('div',{staticClass:"generic-toggle-button__toggle-center"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }